import moment from "moment";

export const getCurrentYear = () => new Date().getFullYear();

export const generateYearRange = (count = 5) => {
  const currentYear = getCurrentYear();
  const years = [];
  for (let i = 0; i <= count; i++) {
    years.push(currentYear - i);
  }
  return years;
};

export const formatPaymentDate = (date) => {
  if (!date) return "N/A";
  return moment(date).format("MMM DD, YYYY");
};
